import { Directive, EventEmitter, ElementRef, Input, Output } from '@angular/core';
import { NgControl } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { messages as i18n } from '@teem/constants/messages';

declare var $: any;

@Directive({
  selector: '[app-select2-multiple]'
})
export class Select2MultipleDirective {
  select2: any;
  model: any;
  selected: any;

  @Input() placeholder: string;
  @Input() options: any;

  @Input('selected')
  set setSelected(val: any) {
    this.selected = val;

    if (this.selected && $(this.el.nativeElement).hasClass('select2-hidden-accessible')) {
      $(this.el.nativeElement).val(this.selected).change();
    }
  }

  @Output() itemSelected: EventEmitter<any> = new EventEmitter<boolean>();
  @Output() onUnselect: EventEmitter<any> = new EventEmitter<any>();
  @Output() ngModelChange: EventEmitter<any> = new EventEmitter();

  constructor(
    protected httpClient: HttpClient,
    private el: ElementRef,
    private control?: NgControl) {
  }

  ngAfterViewInit(): void {
    this.createSelect2();
    this.bindJqueryEnvents();
  }

  bindJqueryEnvents(): void {
    $(this.el.nativeElement).on('change', (event) => {
      if (this.control) {
        this.control.control.setValue($(this.el.nativeElement).select2("val"));
      } else if (this.model) {
        this.ngModelChange.emit($(this.el.nativeElement).select2("val"))
      }
    });

    var currentQuery;
    $(this.el.nativeElement).on('select2:open', (event) => {
      if (this.control)
        this.control.control.markAsTouched();
    })

    $(this.el.nativeElement).on('select2:unselecting', (event) => {
      this.onUnselect.emit({ "event": event, "item": event.params.args.data });
    })
  }

  getData(): Observable<any> {
    let url = this.options.ajax.url;

    return this.httpClient.get(`${url}`).pipe(
      catchError((err: any) => {
        return throwError(err);
      })
    )
  }

  createSelect2(): void {

    let select2Options: any = {
      // 'minimumInputLength': 3,
      allowClear: false,
      multiple: true,
      language: i18n.select2.messages()
    };

    if (this.placeholder) {
      select2Options.placeholder = this.placeholder;
    }

    if (this.options.dropdownParent) {
      select2Options.dropdownParent = $(this.options.dropdownParent).length ? $(this.options.dropdownParent) : null;
    }

    if (this.options.tags) {
      select2Options.tags = true;
    }

    if (this.options?.maxLength) {
      select2Options.maximumSelectionLength = this.options.maxLength;
    }

    // if (this.selected && this.selected.id && this.selected.text) {
    //   select2Options.initSelection = (element, callback) => {
    //     callback(this.selected);
    //   }
    // }

    if (this.options.templateSelection) {
      select2Options.templateSelection = this.options.templateSelection;
    }

    let idColumn = this.options.idColumn ? this.options.idColumn : 'id';
    let textColumn = this.options.textColumn ? this.options.textColumn : 'label';

    if (this.options && this.options.ajax && this.options.ajax.url) {

      this.getData().subscribe(data => {
        // let data = r;

        if (data) {
          let results = data.map(item => {
            return {
              ...item,
              id: item[idColumn],
              text: item[textColumn],
            }
          });

          select2Options.data = results;
          // $(this.el.nativeElement).select2('destroy');
          this.select2 = $(this.el.nativeElement).select2(select2Options);
          $(this.el.nativeElement).siblings('.select2-container').addClass('w-100');

          if (this.selected) {
            $(this.el.nativeElement).val(this.selected).change();
          }
        }
      }, (err) => {
        //
      })

      // Display select2 with default  data
      this.select2 = $(this.el.nativeElement).select2(select2Options);
      $(this.el.nativeElement).siblings('.select2-container').addClass('w-100');
    } else if (this.options.data && this.options.data.length > 0) {
      let results = this.options.data.map(item => {
        return {
          id: item[idColumn],
          text: item[textColumn],
          ...item
        }
      });

      select2Options.data = results;
      // $(this.el.nativeElement).select2('destroy');
      this.select2 = $(this.el.nativeElement).select2(select2Options);
      $(this.el.nativeElement).siblings('.select2-container').addClass('w-100');
    }
  }

  clear() {
    if (this.select2) {

      if (this.control) {
        this.control.control.setValue(null);
      } else if (this.model) {
        this.ngModelChange.emit(null);
      }

      $(this.el.nativeElement).trigger('change.select2');
    }
  }
}